import { Basket } from '../client/src';

export interface BasketDeleted {
  isDeleted: boolean;
}

export const isBasketDeleted = (
  b: Basket | BasketDeleted
): b is BasketDeleted => {
  return (b as BasketDeleted).isDeleted !== undefined;
};
